import { render, staticRenderFns } from "./CertificatePopup.vue?vue&type=template&id=351d73e7&scoped=true"
import script from "./CertificatePopup.vue?vue&type=script&lang=js"
export * from "./CertificatePopup.vue?vue&type=script&lang=js"
import style0 from "./CertificatePopup.vue?vue&type=style&index=0&id=351d73e7&prod&lang=scss&scoped=true"
import style1 from "./CertificatePopup.vue?vue&type=style&index=1&id=351d73e7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "351d73e7",
  null
  
)

export default component.exports